<template>
  <div id="invoice">
    <div class="main-actions">
      <button class="floater" @click="printInvoice()"><i class="far fa-print"></i></button>
    </div>
    <div class="invoice-selected">
      <invoice-template :invoice="invoice"></invoice-template>
    </div>
  </div>
</template>

<script>
import InvoiceTemplate from "@/components/invoice/InvoiceTemplate";
export default {
  name: "Invoice",
  components: {
    InvoiceTemplate
  },
  data() {
    return {};
  },
  computed: {
    invoice() {
      return this.$store.getters.invoiceById(this.$route.params.id);
    }
  },
  methods: {
    printInvoice(){
      window.print()
    }
  }
};
</script>

<style lang="scss">
.invoice-selected {
  width: 21cm;
  margin: 0 auto;
}
@media print {
  .main-actions {
    display: none;
  }
}
</style>
